import React from 'react';
import "./Input.scss"

function Input(props) {
    return (
        <input type={'text'} className={'default-input'} {...props}/>
    );
}

export default Input;